<template>
	<div>
		<app-eye-doc-stepper step="5"></app-eye-doc-stepper>

		<v-container>
			<v-card :loading="loading">
				<v-card-text class="pa-0">
					<v-tabs v-model="tab">
						<v-tab v-for="(report, index) in reports" :key="index" :href="`#tab-${index}`">
							<v-tooltip bottom abolute>
								<template v-slot:activator="{ on }">
									<span v-on="on">{{ report.date }}</span>
								</template>
								<span>
									{{ report.doc }}
									<br />
									{{ report.datetime }}
								</span>
							</v-tooltip>
						</v-tab>
						<v-tab-item v-for="(report, index) in reports" :key="index" :value="'tab-'+index">
							<v-row id="report" dense>
								<v-col v-if="$vuetify.breakpoint.smAndDown" class="text-center" cols="12">
									<v-row align="center" style="height: 100%">
										<v-col cols="12" class="px-4 pt-4">
											<v-img src="/res/logo2.png"></v-img>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" sm="6" md="5">
									<v-card v-if="patient" flat>
										<v-card-title class="title">
											<strong>Patient Information</strong>
										</v-card-title>
										<v-card-text class="black--text">
											Patient ID: {{ patient.id }}
											<br />
											Name: {{ patient.name }}
											<br />
											Date of Birth: {{ patient.birth }}
											<br />
											Age: {{ patient.age }}
											<br />
											Gender: {{ patient.gender }}
											<br />
											Clinic: {{ patient.clinic }}
											<br />
											Referring Physician: {{ patient.referring }}
										</v-card-text>
									</v-card>
								</v-col>
								<v-col v-if="$vuetify.breakpoint.mdAndUp" class="text-center" cols="12" md="2" style="height: inherit">
									<v-row align="center" style="height: 100%">
										<v-col cols="12">
											<v-img src="/res/logo.png"></v-img>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" sm="6" md="5">
									<v-card flat tile>
										<v-card-title class="title">
											<strong>Clinical Information</strong>
										</v-card-title>
										<v-card-text class="black--text">
											<div>Session ID: {{ appointmentId }}</div>
											<div v-for="(result,index2) in checkup" :key="index2">
												{{ result.question }}:
												{{ result.result }}
												<template v-if="result.note">
													-
													{{ result.note }}
												</template>
											</div>
											<v-simple-table dense>
												<thead>
													<th>Measurements</th>
													<th>OD</th>
													<th>OS</th>
												</thead>
												<tbody>
													<tr>
														<td>Visual Acuity</td>
														<td>{{ visualAcuity.right }}</td>
														<td>{{ visualAcuity.left }}</td>
													</tr>
												</tbody>
											</v-simple-table>
										</v-card-text>
									</v-card>
								</v-col>

								<v-col cols="12">
									<v-divider></v-divider>
								</v-col>

								<v-col cols="12" class="headline black--text text-center">Retinal Photos</v-col>

								<v-col cols="12" sm="6">
									<v-card flat tile>
										<v-card-title class="title">Fundus Image of Right Eye (OD)</v-card-title>
										<template v-for="(retina, i) in rightRetinas">
											<v-card-text :key="i" class="pt-0">
												<v-img :src="retina.link" height="300"></v-img>
											</v-card-text>
											<v-card-text :key="i + '_'" class="pt-0 mx-2 black--text">
												<div v-for="(result,index2) in report.report[retina.id]" :key="index2">
													{{ result.question }} -
													{{ result.result }}
													<template v-if="result.note">
														-
														{{ result.note }}
													</template>
												</div>
												<template v-if="lineDifferences[i] > 0 && $vuetify.breakpoint.smAndUp">
													<div v-for="line in lineDifferences[i]" :key="'line' + line">&nbsp;</div>
												</template>
												<v-divider v-if="i != rightRetinas.length-1" class="pb-2 mt-6"></v-divider>
											</v-card-text>
										</template>
									</v-card>
								</v-col>

								<v-col cols="12" sm="6">
									<v-card flat tile>
										<v-card-title class="title">Fundus Image of Left Eye (OS)</v-card-title>
										<template v-for="(retina, i) in leftRetinas">
											<v-card-text :key="i" class="pt-0">
												<v-img :src="retina.link" height="300"></v-img>
											</v-card-text>
											<v-card-text :key="i + '_'" class="pt-0 mx-2 black--text">
												<div v-for="(result,index2) in report.report[retina.id]" :key="index2">
													{{ result.question }} -
													{{ result.result }}
													<template v-if="result.note">
														-
														{{ result.note }}
													</template>
												</div>
												<template v-if="lineDifferences[i] < 0 && $vuetify.breakpoint.smAndUp">
													<div v-for="line in -1*lineDifferences[i]" :key="'line' + line">&nbsp;</div>
												</template>
												<v-divider v-if="i != leftRetinas.length-1" class="pb-2 mt-6"></v-divider>
											</v-card-text>
										</template>
									</v-card>
								</v-col>

								<v-col cols="12">
									<v-divider></v-divider>
								</v-col>

								<v-col cols="12" class="headline black--text text-center">Interpretation & Diagnosis</v-col>

								<v-col cols="6">
									<v-card flat tile>
										<v-card-text class="black--text">
											Moderate non-proliferative diabetic retinapathy
											<br />Diabetic Macular Threat: Present within 1dd of Fovea
										</v-card-text>
									</v-card>
								</v-col>

								<v-col cols="6">
									<v-card flat tile>
										<v-card-text class="black--text">
											Moderate non-proliferative diabetic retinapathy
											<br />Diabetic Macular Threat: Present within 1dd of Fovea
										</v-card-text>
									</v-card>
								</v-col>

								<v-col cols="12">
									<v-divider></v-divider>
								</v-col>

								<v-col cols="12" class="headline black--text text-center">Recommanedation & Treatment Plan</v-col>

								<v-col cols="12" class="text-center">
									<v-card flat tile>
										<v-card-text class="black--text" text-center>
											Refer to Teleretina specialist within
											<strong>{{ nextVisit }}</strong>
										</v-card-text>
									</v-card>
								</v-col>

								<v-col cols="12">
									<v-divider></v-divider>
								</v-col>

								<v-col cols="12">
									<v-card flat tile>
										<v-card-text class="black--text">
											<v-row no-gutters>
												<v-col cols="12" sm="6">Doctor: {{ report.doc }}</v-col>
												<v-col cols="6" sm="3">Date: {{ report.date }}</v-col>
												<v-col cols="6" sm="3">Signature:</v-col>
											</v-row>
										</v-card-text>
									</v-card>
								</v-col>
							</v-row>
						</v-tab-item>
					</v-tabs>
				</v-card-text>
			</v-card>
		</v-container>
	</div>
</template>

<script>
const axios = require("axios");

export default {
	components: {
		"app-eye-doc-stepper": require("@/components/steppers/AppEyeDocStepper.vue")
			.default
	},
	mixins: [
		require("@/mixins/backend-mixin").default,
		require("@/mixins/router-mixin").default,
		require("@/mixins/utilities-mixin").default
	],
	data: () => ({
		appointmentId: null,
		patient: null,
		loading: true,
		reports: [],
		tab: null,
		rightRetinas: [],
		leftRetinas: [],
		checkup: [],
		visualAcuity: {
			left: "...",
			right: "..."
		}
	}),
	computed: {
		lineDifferences() {
			if (this.tab == null) {
				return [];
			}
			var tab = this.tab.split("tab-")[1];
			var report = this.reports[tab].report;

			var diffs = [];
			var length = Math.max(
				this.leftRetinas.length,
				this.rightRetinas.length
			);
			var leftIds = this.leftRetinas.map(retina => retina.id);
			var rightIds = this.rightRetinas.map(retina => retina.id);

			for (var i = 0; i < length; i++) {
				var left = 0;
				if (leftIds[i] && report[leftIds[i]]) {
					left = report[leftIds[i]].length;
				}

				var right = 0;
				if (rightIds[i] && report[rightIds[i]]) {
					right = report[rightIds[i]].length;
				}

				var diff = left - right;
				diffs.push(diff);
			}
			return diffs;
		},
		nextVisit() {
			if (this.tab == null) {
				return "...";
			}

			var min = Infinity;

			var tab = this.tab.split("tab-")[1];
			var report = this.reports[tab].report;

			for (var retina of Object.keys(report)) {
				for (var question of report[retina]) {
					min = Math.min(min, question.duration);
				}
			}

			if (min == 1) {
				min = "1 week";
			} else if (min < 4) {
				min = min + " weeks";
			} else if (min == 4) {
				min = "1 month";
			} else {
				min = min / 4 + " months";
			}

			return min;
		}
	},
	async mounted() {
		this.appointmentId = this.$route.params.appointmentId;
		await this.getReportInfo();
		await this.resolveImages();
		this.loading = false;
	},
	methods: {
		async getReportInfo() {
			var id = this.$route.params.appointmentId;

			const url = this.BACKEND_URL + "/api/report2/" + id;
			const thisVue = this;

			await axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						var appointmentInfo = response.data.appointmentInfo;
						var reports = response.data.reports;
						var checkup = response.data.checkup;

						thisVue.patient = {
							id: appointmentInfo.patient.nationalId,
							name:
								appointmentInfo.patient.FirstName +
								" " +
								appointmentInfo.patient.FatherName +
								" " +
								appointmentInfo.patient.FamilyName,
							birth: appointmentInfo.patient.birth,
							age:
								thisVue.getAge(appointmentInfo.patient.birth) +
								" Years",
							gender: appointmentInfo.patient.gender,
							clinic: appointmentInfo.clinic.description,
							referring:
								appointmentInfo.doc.FirstName +
								" " +
								appointmentInfo.doc.FatherName +
								" " +
								appointmentInfo.doc.FamilyName
						};

						// Flatten json and array
						var newReports = [];
						var dateKeys = Object.keys(reports);
						for (var dateKey of dateKeys) {
							let date = reports[dateKey];
							var keys = Object.keys(date);
							for (var key of keys) {
								var r = {
									report: reports[dateKey][key],
									date: dateKey.substring(0, 10),
									datetime: dateKey,
									doc: key
								};

								newReports.push(r);
							}
						}

						var left = [];
						var right = [];

						thisVue.rightRetinas = checkup.filter(answer => {
							if (answer.question == "Right retina") {
								right.push(answer.id);
								return true;
							}
						});
						thisVue.leftRetinas = checkup.filter(answer => {
							if (answer.question == "Left retina") {
								left.push(answer.id);
								return true;
							}
						});

						for (let date of newReports) {
							for (var report in date.report) {
								for (var question of date.report[report]) {
									var regexp = /\((.*)\)/;
									if (regexp.test(question.result)) {
										var value = question.result.match(
											regexp
										)[1];
										question.result = question.result.replace(
											regexp,
											""
										);
										this.$set(question, "duration", value);
									} else {
										// Doesnt work not sure why !!!???
										this.$set(
											question,
											"duration",
											Infinity
										);
									}
								}
							}
						}

						thisVue.reports = newReports;

						thisVue.visualAcuity.left = checkup.filter(
							answer =>
								answer.question == "Visual acuity" &&
								answer.result == "Left Eye"
						)[0].note;

						thisVue.visualAcuity.right = checkup.filter(
							answer =>
								answer.question == "Visual acuity" &&
								answer.result == "Right Eye"
						)[0].note;

						thisVue.checkup = checkup.filter(
							answer =>
								answer.question != "Left retina" &&
								answer.question != "Right retina" &&
								answer.question != "Visual acuity" &&
								answer.question != "Consent for agreement" &&
								answer.question !=
									"Blood pressure medication" &&
								answer.question != "Last exam was with dilation"
						);

						// Remove No's
						// thisVue.checkup = thisVue.checkup.filter(
						// 	answer => answer.result != "No"
						// );
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		async resolveImages() {
			// TODO
			// link with backend

			for (let retina of this.rightRetinas) {
				retina.link = this.BACKEND_URL + "/storage/" + retina.note;
			}

			for (let retina of this.leftRetinas) {
				retina.link = this.BACKEND_URL + "/storage/" + retina.note;
			}
		}
	}
};
</script>

<style scoped>
.v-data-table td,
.v-data-table th {
	padding: 0 !important;
}
</style>
